<div class="content">
  <h3 class="title">Remitir caso a otra unidad</h3>
  <form [formGroup]="form">
    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline" style="width:100%">
          <mat-label>Unidad destino</mat-label>
          <mat-select formControlName="unitId">
            <mat-option *ngFor="let u of units" [value]="u._id">{{ u.name }} ({{ u.code }})</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12">
        <mat-form-field appearance="outline" style="width:100%">
          <mat-label>Observación (opcional)</mat-label>
          <textarea matInput formControlName="observation"></textarea>
        </mat-form-field>
      </div>
    </div>
  </form>
  <div class="button">
    <button mat-raised-button class="cancel-btn rounded" (click)="cancel()">Cancelar</button>
    <button mat-raised-button class="primary-btn rounded" [disabled]="!form.valid" (click)="submit()">Remitir</button>
  </div>
</div>
